import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { type ReactElement } from 'react'
import { SUT_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  Error,
  GetSutsResponse,
  SutResponse
} from '@eggplant/types'

interface Props {
  params: SutResponse
  onError?: (error: Error) => void
  onSuccess?: (response: GetSutsResponse) => void
  children?: (response: GetSutsResponse) => ReactElement
  shortErrorMessage?: string
}

const PostSutRequest = ({
  params,
  shortErrorMessage,
  onError,
  onSuccess,
  children
}: Props) => {
  const { requestParams } = useGetParamsWithSpaceId<SutResponse|undefined>(params)

  const url = `${SUT_SERVICE}/suts`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='post'
      onError={onError}
      onSuccess={onSuccess}
      params={requestParams}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default PostSutRequest
